import { render, staticRenderFns } from "./DataTreeSettingsList.vue?vue&type=template&id=61ef5588&"
import script from "./DataTreeSettingsList.vue?vue&type=script&lang=js&"
export * from "./DataTreeSettingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports